import { request } from './request';

export async function agentLogin(agentId, password, showToastOnError = true) {
  const res = await request(
    `auth`,
    {
      fetchOptions: {
        method: 'POST',
        body: JSON.stringify({ username: agentId, password: password }),
      },
    },
    null,
    null, // TealiumEvents.loginError,
    showToastOnError,
  );

  return {
    result: res.result,
    httpCode: res.status,
    ok: res.status === 200,
    credentialError: res.status === 401,
    serverError: res.status >= 500,
  };
}
